import { render, staticRenderFns } from "./CVTypeSelfIntro.vue?vue&type=template&id=72435edf"
import script from "./CVTypeSelfIntro.vue?vue&type=script&lang=js"
export * from "./CVTypeSelfIntro.vue?vue&type=script&lang=js"
import style0 from "./CVTypeSelfIntro.vue?vue&type=style&index=0&id=72435edf&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports